// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as StyleguideRouteImport } from './routes/styleguide'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogIdRouteImport } from './routes/blog/$id'
import { Route as GetFoundIndexRouteImport } from './routes/get-found/index'
import { Route as GetFoundCheckoutRouteImport } from './routes/get-found/checkout'
import { Route as GetFoundThankYouRouteImport } from './routes/get-found/thank-you'
import { Route as ProjectIdRouteImport } from './routes/project/$id'
import { Route as SeoAuditIndexRouteImport } from './routes/seo-audit/index'
import { Route as SeoAuditReportIdRouteImport } from './routes/seo-audit/report/$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const PortfolioRoute = PortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const StyleguideRoute = StyleguideRouteImport.update({
            id: '/styleguide',path: '/styleguide',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogIdRoute = BlogIdRouteImport.update({
            id: '/blog/$id',path: '/blog/$id',getParentRoute: () => rootRouteImport
          })
const GetFoundIndexRoute = GetFoundIndexRouteImport.update({
            id: '/get-found/',path: '/get-found/',getParentRoute: () => rootRouteImport
          })
const GetFoundCheckoutRoute = GetFoundCheckoutRouteImport.update({
            id: '/get-found/checkout',path: '/get-found/checkout',getParentRoute: () => rootRouteImport
          })
const GetFoundThankYouRoute = GetFoundThankYouRouteImport.update({
            id: '/get-found/thank-you',path: '/get-found/thank-you',getParentRoute: () => rootRouteImport
          })
const ProjectIdRoute = ProjectIdRouteImport.update({
            id: '/project/$id',path: '/project/$id',getParentRoute: () => rootRouteImport
          })
const SeoAuditIndexRoute = SeoAuditIndexRouteImport.update({
            id: '/seo-audit/',path: '/seo-audit/',getParentRoute: () => rootRouteImport
          })
const SeoAuditReportIdRoute = SeoAuditReportIdRouteImport.update({
            id: '/seo-audit/report/$id',path: '/seo-audit/report/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,CookiePolicyRoute: CookiePolicyRoute,FaqRoute: FaqRoute,PortfolioRoute: PortfolioRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ServicesRoute: ServicesRoute,StyleguideRoute: StyleguideRoute,TermsOfServiceRoute: TermsOfServiceRoute,BlogIdRoute: BlogIdRoute,GetFoundCheckoutRoute: GetFoundCheckoutRoute,GetFoundThankYouRoute: GetFoundThankYouRoute,ProjectIdRoute: ProjectIdRoute,BlogIndexRoute: BlogIndexRoute,GetFoundIndexRoute: GetFoundIndexRoute,SeoAuditIndexRoute: SeoAuditIndexRoute,SeoAuditReportIdRoute: SeoAuditReportIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)